import React from 'react';
import PrimaryButton from 'components/Shared/Buttons/PrimaryButton';

const DialogSaveButton = ({ className, children, onClick, ...rest }) => {
    return (
        <PrimaryButton
            data-testid="dialog-save-btn"
            className={`dark ${className ? className : ''}`}
            text={children}
            handleClick={onClick}
            {...rest}
        />
    );
};

export default DialogSaveButton;
